import Swal from 'sweetalert2';
import manager from 'app/module46/component-manager.js';

manager.register('popup', (component, elements, attributes, properties) => {

	const {
		autoFire,
		forModal,
		delay
	} = attributes;

	const modal = forModal
				? document.querySelector('#' + forModal + '[data-component~=modal]')
				: false;

	const msg = document.querySelector('.form__field_error');
	if(msg) {
		msg.scrollIntoView({ block: 'center' })
	}

	if( ! attributes || autoFire) {

		if(properties.timer) {
			properties.didOpen = (toast) => {
				toast.addEventListener('mouseenter', Swal.stopTimer)
				toast.addEventListener('mouseleave', Swal.resumeTimer)
			}
		}

		setTimeout(() => {
			Swal.fire(properties).then(() => modal ? modal.open() : null)
		}, delay ?? 400);
	}
});
